// 2_components/quantity_discounts.js
// Product-detail quantity discount tiles: shell under availability, tile
// labels/badges, move "Ušetříte" into .p-final-price-wrapper, strip
// price decimals. Called from product_detail before sticky-sell clone.

export function enhanceQuantityDiscounts() {
	const infoWrapper = document.querySelector(".product-top .p-info-wrapper");
	if (!infoWrapper) {
		return;
	}

	const root = infoWrapper.querySelector(".js-quantity-discounts");
	if (!root || root.classList.contains("quantity-discounts--enhanced")) {
		return;
	}

	const priceWrapperEl = infoWrapper.querySelector(".p-final-price-wrapper");
	if (!priceWrapperEl) {
		return;
	}

	if (priceWrapperEl.querySelector(".price-standard")) {
		root.classList.add("quantity-discounts--hidden");
		return;
	}

	root.classList.add("quantity-discounts--enhanced");

	const items = root.querySelectorAll(".js-quantity-discounts__item");
	items.forEach(function (item) {
		enhanceQuantityDiscountItem(item);
	});

	const saveEl = root.querySelector(".quantity-discounts__save");
	if (saveEl) {
		const savedAmount = saveEl.querySelector(".js-quantity-discounts__saved-amount");
		const savePrefix = window.NAT.translations("quantityDiscountSavePrefix");
		if (savePrefix && savedAmount) {
			saveEl.replaceChildren(document.createTextNode(savePrefix + " "), savedAmount);
		}
	}

	const shell = document.createElement("div");
	shell.className = "nat-quantity-discounts-shell";

	const availability = infoWrapper.querySelector(".dostupnost-doruceni-wrapper");
	if (availability && availability.parentNode === infoWrapper) {
		availability.insertAdjacentElement("afterend", shell);
	} else {
		infoWrapper.insertBefore(shell, priceWrapperEl);
	}

	shell.appendChild(root);
	shell.appendChild(priceWrapperEl);

	const priceInfo = document.createElement("div");
	priceInfo.className = "nat-qty-price-info";
	const priceChildren = Array.from(priceWrapperEl.children).filter(function (child) {
		return !child.classList.contains("add-to-cart");
	});
	priceChildren.forEach(function (child) {
		priceInfo.appendChild(child);
	});
	if (saveEl) {
		priceInfo.prepend(saveEl);
	}
	const addToCart = priceWrapperEl.querySelector(".add-to-cart");
	if (addToCart) {
		priceWrapperEl.insertBefore(priceInfo, addToCart);
	} else {
		priceWrapperEl.appendChild(priceInfo);
	}

	stripQuantityDiscountPriceDecimals(shell);
	bindQuantityDiscountPriceDecimals(shell);
	bindFinalVatPriceSync(shell);
	syncFinalVatPrice(shell);
}

function stripPriceDecimalPart(text) {
	if (!text) {
		return text;
	}
	return text.replace(/,\d{1,2}(?=\s|$)/g, "");
}

function stripQuantityDiscountPriceDecimals(root) {
	root.querySelectorAll(".quantity-discounts__price, .js-quantity-discounts__saved-amount").forEach(function (el) {
		const next = stripPriceDecimalPart(el.textContent);
		if (next !== el.textContent) {
			el.textContent = next;
		}
	});
}

function bindQuantityDiscountPriceDecimals(root) {
	if (root.dataset.natPriceDecimalsBound === "1") {
		return;
	}
	root.dataset.natPriceDecimalsBound = "1";

	let syncing = false;
	const observer = new MutationObserver(function () {
		if (syncing) {
			return;
		}
		syncing = true;
		stripQuantityDiscountPriceDecimals(root);
		syncing = false;
	});
	observer.observe(root, {
		subtree: true,
		characterData: true,
		childList: true,
	});
}

function parsePriceNumber(text) {
	if (!text) {
		return NaN;
	}
	const normalized = text
		.replace(/\u00a0/g, " ")
		.replace(/[^\d,.\s]/g, "")
		.replace(/\s/g, "")
		.replace(",", ".");
	return parseFloat(normalized);
}

function formatPriceNumber(value) {
	const rounded = Math.round(value);
	if (!Number.isFinite(rounded)) {
		return "";
	}
	const currency = window.NAT.translations("currencySymbol");
	const formatted = String(rounded).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
	return currency ? formatted + " " + currency : formatted;
}

function formatPerUnitPrice(value) {
	if (!Number.isFinite(value)) {
		return "";
	}
	const fixed = value.toFixed(2).replace(".", ",");
	return fixed.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

function ensurePerUnitBase(span) {
	if (span.dataset.natBasePerUnitText) {
		return true;
	}
	const text = span.textContent.replace(/\u00a0/g, " ").trim();
	if (!text) {
		return false;
	}
	span.dataset.natBasePerUnitText = text;
	const match = text.match(/^([\d\s]+(?:[,.]\d+)?)\s*(\S+)\s*\/\s*(.+)$/);
	if (!match) {
		return false;
	}
	span.dataset.natBasePerUnitValue = String(parsePriceNumber(match[1]));
	span.dataset.natPerUnitCurrency = match[2];
	span.dataset.natPerUnitSuffix = match[3].trim();
	return Number.isFinite(parseFloat(span.dataset.natBasePerUnitValue));
}

function syncPricePerUnit(shell, ratio) {
	const span = shell.querySelector(".product-price-per-unit-value-detail");
	if (!span || !ensurePerUnitBase(span)) {
		return;
	}

	if (!Number.isFinite(ratio) || ratio >= 1) {
		span.textContent = span.dataset.natBasePerUnitText;
		return;
	}

	const base = parseFloat(span.dataset.natBasePerUnitValue);
	const formatted = formatPerUnitPrice(base * ratio);
	if (!formatted) {
		return;
	}
	span.textContent = formatted + " " + span.dataset.natPerUnitCurrency + " / " + span.dataset.natPerUnitSuffix;
}

function syncFinalVatPrice(shell) {
	const holder = shell.querySelector(".price-final-holder");
	if (!holder) {
		return;
	}

	if (!holder.dataset.natBasePrice) {
		holder.dataset.natBasePrice = holder.textContent.replace(/\u00a0/g, " ").trim();
	}

	const item = shell.querySelector(".quantity-discounts__item--highlighted");
	if (!item || item.dataset.amount === "1") {
		holder.textContent = holder.dataset.natBasePrice;
		syncPricePerUnit(shell, 1);
		return;
	}

	const ratio = parseFloat(item.dataset.priceRatio);
	const priceEl = item.querySelector(".quantity-discounts__price");
	if (priceEl) {
		const tilePrice = priceEl.textContent.replace(/\u00a0/g, " ").trim();
		if (tilePrice) {
			holder.textContent = tilePrice;
			syncPricePerUnit(shell, ratio);
			return;
		}
	}

	const base = parsePriceNumber(holder.dataset.natBasePrice);
	if (!Number.isFinite(base) || !Number.isFinite(ratio)) {
		return;
	}
	holder.textContent = formatPriceNumber(base * ratio);
	syncPricePerUnit(shell, ratio);
}

function quantityDiscountAmountInRange(item) {
	const input = document.querySelector(".product-top .quantity input.amount");
	if (!input) {
		return false;
	}

	const amount = parseFloat(item.dataset.amount);
	if (!Number.isFinite(amount)) {
		return false;
	}

	const min = parseFloat(input.min);
	const max = parseFloat(input.max);
	if (Number.isFinite(min) && amount < min) {
		return false;
	}
	if (Number.isFinite(max) && amount > max) {
		return false;
	}
	return true;
}

function suppressInRangeQuantityNotice(item) {
	if (!quantityDiscountAmountInRange(item)) {
		return;
	}
	if (typeof shoptet === "undefined" || !shoptet.quantity || typeof shoptet.quantity.enforceAndAnnounceLimits !== "function") {
		return;
	}

	const original = shoptet.quantity.enforceAndAnnounceLimits;
	let restored = false;
	const restore = function () {
		if (restored) {
			return;
		}
		restored = true;
		if (shoptet.quantity.enforceAndAnnounceLimits === wrapped) {
			shoptet.quantity.enforceAndAnnounceLimits = original;
		}
	};
	const wrapped = function (el) {
		restore();
		const value = parseFloat(el.value);
		const min = parseFloat(el.min);
		const max = parseFloat(el.max);
		if ((Number.isFinite(min) && value < min) || (Number.isFinite(max) && value > max)) {
			return original.call(shoptet.quantity, el);
		}
	};

	shoptet.quantity.enforceAndAnnounceLimits = wrapped;
	window.setTimeout(restore, 0);
}

function bindFinalVatPriceSync(shell) {
	if (shell.dataset.natFinalPriceBound === "1") {
		return;
	}
	shell.dataset.natFinalPriceBound = "1";

	let syncing = false;
	const runSync = function () {
		if (syncing) {
			return;
		}
		syncing = true;
		stripQuantityDiscountPriceDecimals(shell);
		syncFinalVatPrice(shell);
		syncing = false;
	};

	shell.addEventListener(
		"click",
		function (event) {
			const item = event.target.closest(".js-quantity-discounts__item");
			if (!item) {
				return;
			}
			suppressInRangeQuantityNotice(item);
		},
		true
	);

	shell.addEventListener("click", function (event) {
		if (event.target.closest(".js-quantity-discounts__item")) {
			window.setTimeout(runSync, 0);
		}
	});

	const observer = new MutationObserver(runSync);
	observer.observe(shell.querySelector(".js-quantity-discounts") || shell, {
		subtree: true,
		attributes: true,
		attributeFilter: ["class"],
		characterData: true,
		childList: true,
	});
}

function enhanceQuantityDiscountItem(item) {
	const title = item.querySelector(".quantity-discounts__title");
	const priceWrap = item.querySelector(".quantity-discounts__price-wrapper");
	if (!title || !priceWrap) {
		return;
	}

	const amount = item.dataset.amount || "1";
	const originalTitle = title.textContent || "";
	const unitMatch = originalTitle.match(/\b(ks|szt\.?)\b/i);
	const unit = unitMatch ? unitMatch[1] : "ks";
	const isPlus = /více|viac|more|\+/i.test(originalTitle);
	const amountLabel = isPlus ? amount + "+ " + unit : amount + " " + unit;
	title.textContent = amountLabel;
	title.classList.add("quantity-discounts__amount");

	if (amount === "1") {
		if (!item.querySelector(".quantity-discounts__no-discount")) {
			const noDiscount = window.NAT.translations("quantityDiscountNoDiscount");
			if (noDiscount) {
				const label = document.createElement("span");
				label.className = "quantity-discounts__no-discount";
				label.textContent = noDiscount;
				priceWrap.insertAdjacentElement("afterend", label);
			}
		}
		return;
	}

	const ratio = parseFloat(item.dataset.priceRatio);
	const pct = Number.isFinite(ratio) ? Math.round((1 - ratio) * 100) : 0;

	if (pct >= 4 && !item.querySelector(".quantity-discounts__badge")) {
		const badge = document.createElement("span");
		badge.className = "quantity-discounts__badge";
		badge.textContent = "-" + pct + " %";
		priceWrap.insertAdjacentElement("afterend", badge);
	}
}
